import { qs } from "./utils"

export const initNewsletterButton = () => {
  const newsletterContainer = qs(".sticky-newsletter-container")
  const closeButton = qs("#sticky-newsletter-button-close")

  if (!newsletterContainer) return

  const SCROLL_THRESHOLD =
    Number.parseInt(newsletterContainer.dataset.scrollThreshold) || 0
  let isVisible = false
  let ticking = false

  const updateButtonVisibility = () => {
    const scrollY = window.scrollY
    const shouldShow =
      scrollY >= SCROLL_THRESHOLD &&
      sessionStorage.getItem("newsletter-button-closed") !== "true"

    if (shouldShow !== isVisible) {
      isVisible = shouldShow
      newsletterContainer.classList.toggle("visible", shouldShow)
    }
    ticking = false
  }

  const onScroll = () => {
    if (!ticking) {
      requestAnimationFrame(updateButtonVisibility)
      ticking = true
    }
  }

  // Initial check
  updateButtonVisibility()

  // Listen for scroll events
  window.addEventListener("scroll", onScroll, { passive: true })

  // Handle close button click
  if (closeButton) {
    closeButton.addEventListener("click", () => {
      newsletterContainer.classList.remove("visible")
      isVisible = false
      sessionStorage.setItem("newsletter-button-closed", "true")
    })
  }
}
